<template>
  <div id="app">
    <!-- <school-dlog @schoolData="schoolData"></school-dlog>
    <teacher-dlog :schoolId="course.schoolid" @teacherData="teacherData"></teacher-dlog> -->
    <el-page-header @back="goBack" :content="title"> </el-page-header>
    <el-divider></el-divider>
    <el-form
      v-loading="courseload"
      :model="course"
      :rules="rules"
      ref="course"
      label-width="110px"
      size="medium"
    >
      <el-form-item label="课程类型：" prop="type">
        <el-button
          round
          size="small"
          :type="item.id == type ? 'primary' : ''"
          v-for="item in typeList"
          :key="item.id"
          :disabled="course.id !== 0 || item.disabled"
          @click.native="chooseType(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
      <el-form-item label="课程分类：" prop="types">
        <el-button
          round
          size="small"
          :type="item.id == course.types ? 'primary' : ''"
          v-for="item in classify"
          :key="item.id"
          @click.native="chooseTypes(item)"
          >{{ item.classifyName }}</el-button
        >
      </el-form-item>
      <!-- <el-form-item label="直播学校：" v-show="false" prop="schoolName">
        <el-input
          size="small"
          placeholder="请选择直播学校"
          v-model="course.schoolName"
          clearable
          disabled
          style="width: 220px"
        ></el-input>
        <school-dlog
          :schoolIds="course.schoolid"
          @schoolData="schoolData"
        ></school-dlog>
        <el-button size="small" @click.native="clearSchool">清空</el-button>
      </el-form-item> -->
      <!-- prop="courseSpeaker" -->
      <el-form-item label="主讲人：">
        <el-input
          size="small"
          placeholder="请选择主讲人"
          v-model="course.courseSpeaker"
          clearable
          disabled
          style="width: 220px"
        ></el-input>
        <!-- <el-button type="primary" @click.native="openTeacherDialog"
          >选择</el-button
        > -->
        <teacher-dlog
          :teachers="teacher"
          :schoolId="course.schoolid"
          @teacherData="teacherData"
        ></teacher-dlog>
        <el-button size="small" @click.native="clearTeacher">清空</el-button>
      </el-form-item>
      <el-form-item label="公开范围：" prop="courseLimit">
        <el-radio-group @change="scopeChange" v-model="course.courseLimit">
          <el-radio
            :label="list.code.toString()"
            v-for="(list, index) in courseLimit"
            :key="index"
            >{{ list.name }}
            <span v-if="list.code == '3'"
              ><span
                v-if="baseSchoolIds.length !== 0 || authSchoolIds.length !== 0"
                >{{ baseSchoolIds.length + authSchoolIds.length }}所</span
              ></span
            ></el-radio
          >
        </el-radio-group>
        <div class="school_list"></div>
      </el-form-item>
      <el-form-item v-if="course.courseLimit == 3">
        <div class="base_list">
          <el-checkbox-group v-model="baseSchoolIds">
            <el-checkbox
              v-for="item in baseSchoolList"
              :key="item.id"
              :label="item.id"
              >{{ item.name
              }}<span class="listNum"> (基地校)</span></el-checkbox
            >
          </el-checkbox-group>
          <el-divider></el-divider>
          <el-checkbox-group v-model="authSchoolIds">
            <el-checkbox
              v-for="item in authSchoolList"
              :key="item.id"
              :label="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </el-form-item>
      <el-form-item v-if="course.courseLimit == 5">
        <div class="base_list">
          <el-table
            :row-style="{ height: '48px' }"
            :data="userList"
            :show-header="false"
            style="width: 100%"
          >
            <el-table-column type="expand">
              <template slot-scope="scope">
                <el-checkbox-group
                  @change="groupStudent(scope.row)"
                  v-model="scope.row.userIds"
                >
                  <el-checkbox
                    style="margin-bottom: 10px"
                    v-for="item in scope.row.teamUsers"
                    :key="item.teacherId"
                    :label="item.teacherId"
                    >{{ item.teacherName }} (
                    {{ item.schoolName }} )</el-checkbox
                  >
                </el-checkbox-group>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-checkbox
                  @change="groupChange(scope.row.groupIds, scope.row.id)"
                  v-model="scope.row.groupIds"
                  :disabled="scope.row.teamUsers.length == 0"
                  >{{ scope.row.teamName }}</el-checkbox
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <!-- :prop="type == 1 ? '' : 'bookName'" -->
      <el-form-item label="教材：">
        <!-- 学科 -->
        <el-select
          v-model="subject"
          filterable
          size="small"
          @change="subjectChange"
          placeholder="请选择学科"
          style="width: 150px"
        >
          <el-option
            v-for="item in subjectList"
            :key="item.id"
            size="small"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- 年级 -->
        <el-select
          v-model="grade"
          filterable
          size="small"
          @change="gradeChange"
          placeholder="请选择年级"
          style="width: 150px"
        >
          <el-option
            v-for="item in gradeList"
            :key="item.gradeId"
            :label="item.name"
            :value="item.gradeId"
          ></el-option>
        </el-select>
        <!-- 教材 -->
        <el-select
          v-model="book"
          filterable
          size="small"
          placeholder="请选择教材"
          style="width: 150px"
        >
          <el-option
            v-for="item in bookList"
            :key="item.bookId"
            :label="item.bookName"
            :value="item.bookId"
            @click.native="changeBook(item)"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- :prop="type == 1 ? '' : 'chapterName'" -->
      <el-form-item label="章节：">
        <el-input
          placeholder="请选择章节"
          v-model="course.chapterName"
          size="small"
          clearable
          disabled
          style="width: 220px"
        ></el-input>
        <el-button size="small" type="primary" @click.native="openChapterDialog"
          >选择</el-button
        >
        <el-button size="small" @click.native="clearChapter">清空</el-button>
      </el-form-item>
      <el-form-item label="课程名称：" prop="courseName">
        <el-input
          placeholder="请输入课程名称"
          v-model="course.courseName"
          clearable
          style="width: 220px"
        ></el-input>
      </el-form-item>
      <el-form-item label="课程介绍：" prop="noteContent">
        <quill-editor
          v-model="course.noteContent"
          ref="myQuillEditor"
          class="editor"
          :options="editorOption"
        ></quill-editor>
      </el-form-item>
      <el-form-item label="课程封面：">
        <el-upload
          ref="upload"
          class="cover-uploader"
          :headers="headers"
          :data="datas"
          :action="uploadurl"
          :on-success="uploadImageSuccess"
          accept="image/*"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
        >
          <div
            v-loading="loading"
            element-loading-text="上传中..."
            element-loading-background="rgba(0, 0, 0, 0.7)"
          >
            <img v-if="course.thumb" :src="course.thumb" class="cover" />
            <i v-else class="el-icon-picture cover-uploader-icon"></i>
          </div>
        </el-upload>
        <span class="cover-text">图片建议尺寸：220*120</span>
      </el-form-item>
      <el-form-item label="推荐到首页：" prop="home" v-show="false">
        <el-tooltip
          :content="course.home == '0' ? '取消荐到首页' : '确认推荐到首页'"
          placement="top"
        >
          <el-switch
            v-model="course.home"
            active-color="#409EFF"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </el-tooltip>
      </el-form-item>
      <el-form-item class="course-save">
        <el-button size="small" type="primary" @click.native="saveCourse(1)"
          >发布</el-button
        >
        <el-button
          size="small"
          type="primary"
          plain
          @click.native="saveCourse(0)"
          >存草稿</el-button
        >
        <el-button size="small" type="primary" @click.native="tiansj()"
          >继续添加</el-button
        >
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <add-class
      ref="addClass"
      :type="type"
      :courseName="course.courseName"
      :courseId="courseId"
    ></add-class>
    <!--选择章节-->
    <el-dialog
      title="选择章节"
      v-if="chapterDialog"
      v-loading="chapterState"
      :visible.sync="chapterDialog"
    >
      <div class="chapter-main">
        <el-tree
          :data="chapterList"
          show-checkbox
          node-key="chapterId"
          :default-checked-keys="[chapterid]"
          @check="chooseChapter"
          :props="defaultProps"
          :default-expand-all="true"
          ref="chapterTree"
        ></el-tree>
        <div class="course-ok-btn">
          <el-button
            size="small"
            type="primary"
            @click.native="closeChapterDialog"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import schoolDlog from "../public/schoolDlog";
import teacherDlog from "../public/teacherDlog";
import addClass from "./addClass";
import * as homeApi from "@/api/home";
import { ERR_OK, BASE_URLLIST } from "@/api/index";
//加密解密
import utils from "@/api/utils";
//日期格式化
import moment from "moment";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
  [{ size: ["small", false, "large", "huge"] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  [{ font: [] }], // 字体种类-----[{ font: [] }]
  [{ align: [] }], // 对齐方式-----[{ align: [] }]
  ["clean"], // 清除文本格式-----['clean']
  ["image"], // 链接、图片、视频-----['link', 'image', 'video']
];
export default {
  components: {
    // 声明子组件名字
    schoolDlog,
    teacherDlog,
    quillEditor,
    addClass,
  },
  data() {
    //教材选择
    let vBookName = (rule, value, callback) => {
      if (this.book === "") {
        callback(new Error("请选择教材"));
      } else {
        callback();
      }
    };
    //视频地址
    let videoLink = (rule, value, callback) => {
      //直播
      if (this.type == 1) {
        if (this.classinfo.link == "") {
          callback(new Error("请输入直播拉流地址"));
        } else {
          // //正则验证网址
          // const reg = /((ht|f)tps?:)\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
          // if (!reg.test(this.classinfo.link)) {
          //   callback(new Error('请输入合法的直播推流地址'))
          // } else {
          //   callback()
          // }
          callback();
        }
      } else {
        callback();
      }
    };
    //直播时间
    let videoTime = (rule, value, callback) => {
      //直播验证
      if (this.type == 1) {
        //直播时间
        if (this.classinfo.stime == "") {
          callback(new Error("请选择开始时间"));
        } else if (this.classinfo.etime == "") {
          callback(new Error("请选择结束时间"));
        } else {
          //开始时间
          let stime = Date.parse(this.classinfo.stime);
          //结束时间
          let etime = Date.parse(this.classinfo.etime);
          if (stime > etime) {
            callback(new Error("开始时间不能大于结束时间"));
          } else {
            callback();
          }
        }
      } else {
        //点播不验证
        callback();
      }
    };
    let videoTimes = (rule, value, callback) => {
      //直播验证
      if (this.type == 1) {
        //直播时间
        if (this.form.beginTime == "") {
          callback(new Error("请选择开始时间"));
        } else if (this.form.endTime == "") {
          callback(new Error("请选择结束时间"));
        } else {
          callback();
        }
      } else {
        //点播不验证
        callback();
      }
    };
    return {
      title: "添加课程",
      datas: {
        bucketId: 1,
      }, //限制上传数量
      editorOption: {
        placeholder: "请输入活动内容",
        theme: "snow",
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector(".poujj input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      }, // 富文本配置
      courseload: false,
      typeList: [
        { id: 1, name: "直播" },
        { id: 2, name: "点播" },
      ], //课程类型列表
      type: 1, //课程类型
      subjectList: [{ id: "", name: "请选择学科" }], //学科列表
      subject: "", //学科选择
      sstate: false, //学科编辑
      gradeList: [{ gradeId: "", name: "请选择年级" }], //年级列表
      grade: "", //年级选择
      gstate: false, //年级编辑
      bookList: [{ bookId: "", bookName: "请选择教材" }], //教材列表
      book: "", //教材选择
      thumb: "", //上传显示封面
      thumbName: "", //上传封面名称
      headers: {
        token: localStorage.getItem("token"), //文件上传请求头
      },

      teacher: [], //教师数据
      classify: [], //课程分类
      chapterDialog: false, //章节弹窗
      uploadurl: homeApi.urls + "/file/oss-upload", //上传图片地址
      limit: 1, //上传视频个数
      course: {
        id: 0, //课程ID
        schoolid: 0, //学校ID
        schoolName: "", //课程学校
        courseSpeaker: "", //主讲人
        bookName: "", //教材
        chapterName: "", //章节
        courseName: "", //课程名称
        thumb: "", //课程封面
        home: "0", //是否推荐到首页
        types: 1,
        noteContent: "", //课程介绍
        courseLimit: "", //公开范围
        commentsIsOpen: "0", // 开放评论
        spectatorIsOpen: "0", //观众列表
        visitorIsOpen: "0", //游客是否能够评论
      },
      courseLimit: [], // 公开范围列表
      rules: {
        live_status: [
          { required: true, message: "请选择直播状态", trigger: "blur" },
        ],
        courseLimit: [
          {
            required: true,
            message: "请选择公开范围",
            trigger: "blur",
          },
        ],
        types: [{ required: true, message: "请选择课程分类", trigger: "blur" }],
        courseSpeaker: [
          { required: true, message: "请选择主讲人", trigger: "blur" },
        ],
        bookName: [{ required: true, validator: vBookName, trigger: "change" }],
        chapterName: [
          { required: true, message: "请选择章节", trigger: "blur" },
        ],
        link: [{ required: true, validator: videoLink, trigger: "blur" }],
        room_type: [
          { required: true, message: "请选择直播类型", trigger: "blur" },
        ],
        videoTime: [
          {
            type: "date",
            required: true,
            validator: videoTime,
            trigger: "change",
          },
        ],
        roomtyps: [
          { required: true, message: "请选择直播分类", trigger: "blur" },
        ],
      },
      dtype: 1, //上传方式
      videoList: [], //视频列表
      resultVideoList: [], //最终视频列表
      filetypes: [], //上传类型列表
      fileTypeList: [], //上传资源类型
      filetypeid: 0, //上传类型ID
      filetype: "", //默认类型
      fileList: [], //资源列表
      resultList: [], //最终资源列表
      loading: false, //上传状态
      chapterList: [], //章节列表
      chapter: [], //章节选择
      chapterid: 0, //章节ID
      defaultProps: {
        children: "chapterList",
        label: "chapterName",
      }, //设置树节点属性
      chapterDialog: false, //章节弹窗
      chapterState: false, //加载状态
      courseId: 0, //课程ID
      groupId: 0, //学校所属集团校
      //schoolIds: [],
      baseSchoolList: [], // 基地校列表
      authSchoolList: [], // 非基地校列表
      baseSchoolIds: [], // 基地校Id列表
      authSchoolIds: [], // 非基地校Id列表
      userList: [], // 小组列表
      teacherIds: [], //教师选中列表
      page: 1, // 记录页数
      liveNum: 0, //直播次数
    };
  },
  created() {
    setTimeout(() => {
      if (localStorage.getItem("schoolId")) {
      const id=localStorage.getItem("schoolId")
      console.log(id)
      this.course.schoolid = Number(id);
      //判断直播次数
      homeApi
        .getCourseRight({
          schoolId: this.course.schoolid,
          courseType: this.course.types,
        })
        .then((res) => {
          this.liveNum = res.data.data;
          this.typeList[0].name = "直播(" + this.liveNum + "/3)次";
          // if (this.liveNum == 3) {
          //   this.type = 2;
          //   this.typeList[0].disabled = true;
          // }
        });
    }
    }, 100);
    let courseId = this.$route.query.id;
    this.page = this.$route.query.page;
    if (!!courseId) {
      this.course.id = courseId;
      this.courseId = courseId;
      this.title = "编辑课程";
      this.getCourseInfo();
    }
    let declareId = this.$route.query.declareId;
    if (!!declareId) {
      this.selectByPrimaryKey(declareId);
    }
    this.dictcode();
    this.courseclassify();
    //初始化数据
    this.dataInit();
  },
  methods: {
    // 获取申报录课详细信息
    selectByPrimaryKey(id) {
      let _this = this;
      homeApi.selectByPrimaryKey({ id }).then((res) => {
        let info = res.data.data;
        _this.course.courseName = info.courseName; //课程名称
        _this.course.schoolName = info.schoolName; //学校姓名
        _this.nowSchool = info.schoolName; //当前选择的学校
        _this.course.schoolid = info.schoolId; //学校ID
        _this.subject = info.subjectId; //学科
        _this.grade = info.gradeId; //年级
        let tlist = []; //主讲人列表
        let list = { id: info.creatorId, name: info.creatorName };
        tlist.push(list);
        _this.teacher = tlist;
        _this.course.courseSpeaker = _this.getTeacherName(tlist); //主讲人字符串
        _this.course.noteContent = info.courseKeynote;
        this.schoolgetinfo();
      });
    },
    //获取课程详情
    getCourseInfo() {
      if (this.course.id > 0) {
        //参数
        let params = {
          id: this.course.id,
        };
        //开启加载
        this.courseload = true;
        this.classload = true;
        let _this = this;
        //接口
        homeApi
          .getCourseInfo(params)
          .then((res) => {
            //关闭加载
            _this.courseload = false;
            _this.classload = false;
            let { data } = res;
            if (data.code === ERR_OK) {
              let info = data.data;
              if (info) {
                _this.sstate = true; //学科编辑
                _this.gstate = true; //年级编辑
                _this.book = info.bookId; //教材

                _this.course.id = info.courseId; //课程ID
                _this.course.courseName = info.courseName; //课程名称
                _this.type = info.courseTypeid; //课程类型
                _this.course.schoolid = info.schoolId; //学校ID
                _this.course.schoolName = info.schoolName; //学校姓名
                _this.nowSchool = info.schoolName; //当前选择的学校
                _this.course.types = info.courseClassify; //课程类型
                _this.course.noteContent = info.courseInfo;
                _this.course.courseLimit = info.courseLimit.toString();
                let school = { id: info.schoolId, name: info.schoolName };
                _this.school = school; //默认学校选中项
                //_this.schoolIds = info.schoolIds; //默认学校列表选中项
                _this.teacherIds = info.teacherIds; //默认小组列表选中项
                // _this.course.commentsIsOpen = info.commentsIsOpen + ""; //评论列表
                // _this.course.spectatorIsOpen = info.spectatorIsOpen + ""; //观众列表
                // _this.course.visitorIsOpen = info.visitorIsOpen + ""; //游客是否能够评论

                _this.schoolgetinfo("1");

                let tlist = []; //主讲人列表
                info.teachers.forEach((res) => {
                  let list = { id: res.userId, name: res.userName };
                  tlist.push(list);
                });
                _this.teacher = tlist;
                _this.course.courseSpeaker = _this.getTeacherName(tlist); //主讲人字符串
                _this.subject = info.subjectId; //学科
                _this.grade = info.gradeId; //年级
                _this.getBookList();
                _this.chapterid = info.chapterId; //章节id
                _this.course.chapterName = info.chapterName; //章节名称
                _this.chapter = [
                  { chapterId: info.chapterId, chapterName: info.chapterName },
                ]; //选择章节信息

                _this.serverHttp = info.serverHttp; //主机头地址
                _this.thumbName = info.courseImg; //课程封面名称
                _this.course.thumb = info.serverHttp + info.courseImg; //课程封面
                _this.thumb = info.serverHttp + info.courseImg; //课程封面
                _this.course.home = "" + info.courseRecomend; //是否推荐到主页
              }
            }
          })
          .catch((error) => {
            //关闭加载
            _this.courseload = false;
            _this.classload = false;
            console.log(error);
          });
      }
    },
    //获取主讲人
    getTeacherName(v) {
      let teacherName = "";
      v.forEach((res) => {
        teacherName += res.name + "、";
      });
      teacherName =
        teacherName != ""
          ? teacherName.substring(0, teacherName.length - 1)
          : teacherName;
      return teacherName;
    },
    //   初始化函数
    dataInit() {
      //请求头
      //   this.getHeaders()
      //获取传递参数
      //   this.getQuery()
      //获取课程详情
      //   this.getCourseInfo();
      //获取课程类型列表
      //   this.getCourseTypeList();
      //获取学科列表
      this.getSubjectList();
      //获取年级列表
      this.getGradeList();
      //获取上传资源类型
      //   this.getResTypeList()
    },
    //   返回上一级
    goBack() {
      this.$router.push({
        path: "/dplay",
      });
    },
    // 获取学校数据 传值
    schoolData(val) {
      this.course.schoolid = val.id;
      this.course.schoolName = val.name;
      this.schoolgetinfo();
    },
    // 获取教师数据 传值
    teacherData(val) {
      this.teacher = val;
      if (this.teacher.length !== 0) {
        let name = [];
        this.teacher.forEach((res) => {
          name.push(res.name);
        });
        this.course.courseSpeaker = name.toString();
      }
    },
    // 获取课程分类
    courseclassify() {
      let that = this;
      homeApi
        .courseclassify()
        .then((res) => {
          that.classify = res.data.data;
        })
        .catch(() => {});
    },
    //选择课程类型
    chooseType(v) {
      this.type = v.id;
      this.$refs.addClass.changeAddClass(v.id);
    },
    // 选择课程分类
    chooseTypes(v) {
      this.course.types = v.id;
    },
    // 获取公开范围
    dictcode() {
      // let that = this;
      // let params = {
      //   code: "courseLimit",
      // };
      // //接口
      // homeApi
      //   .dictcode(params)
      //   .then((res) => {
      //     that.courseLimit = res.data.data;
      //   })
      //   .catch((error) => {});
      this.courseLimit = [
        { id: 333, code: "2", name: "本校" },
        { id: 337, code: "10", name: "公开课" },
      ];
    },
    //清除选择学校
    clearSchool() {
      this.schoolSearch = "";
      this.schoolPage = 1;
      this.schoolList = [];
      this.schoolTotalcount = 0;
      this.course.schoolid = 0;
      this.course.schoolName = "";
      this.school = "";
      //清除名师选择
      this.clearTeacher();
    },
    //清除选择名师
    clearTeacher() {
      this.teacherSearch = "";
      this.teacherPage = 1;
      this.teacherList = [];
      this.teacherTotalcount = 0;
      this.course.courseSpeaker = "";
      this.teacher = [];
    },
    //显示章节弹窗
    openChapterDialog() {
      //显示弹窗
      this.chapterDialog = true;
      this.getBookTreeList();
    },
    //隐藏章节弹窗
    closeChapterDialog() {
      this.chapterDialog = false;
    },
    //获取学科列表
    getSubjectList() {
      //参数
      let params = {};
      let _this = this;
      //接口
      homeApi
        .getSubjectList(params)
        .then((res) => {
          let { data } = res;
          if (data.code === ERR_OK) {
            let list = data.data;
            //获取学科列表
            _this.subjectList = list;
            _this.subjectList.unshift({
              id: "",
              name: "请选择学科",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 学科列表变化
    subjectChange() {
      this.getBookList();
    },
    //获取年级列表
    getGradeList() {
      //参数
      let params = {
        schoolId: 0,
      };
      let _this = this;
      //接口
      homeApi
        .getGradeList(params)
        .then((res) => {
          let { data } = res;
          if (data.code === ERR_OK) {
            let list = data.data;
            //获取年级列表
            _this.gradeList = list;
            _this.gradeList.unshift({
              gradeId: "",
              name: "请选择年级",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 年级列表变化
    gradeChange() {
      this.getBookList();
    },
    //获取教材列表
    getBookList() {
      //参数
      let params = {};
      //科目
      if (this.subject > 0) {
        params.subjectId = this.subject;
      }
      //年级
      if (this.grade > 0) {
        params.gradeId = this.grade;
      }
      let _this = this;
      //接口
      homeApi
        .getBookList(params)
        .then((res) => {
          let { data } = res;
          if (data.code === ERR_OK) {
            let list = data.data.dataList;
            //获取教材列表
            _this.bookList = list;
            _this.bookList.unshift({
              bookId: "",
              bookName: "请选择教材",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //开始上传前
    beforeAvatarUpload(file) {
      //上传加载中
      this.loading = true;
      //判断是否为图片格式
      const isImage = file.type.indexOf("image");
      //上传大小
      const fileSize = 100 * 1024 * 1000;
      if (isImage < 0) {
        // this.$toast.center("只能上传图片格式");
      }
      if (file.size > fileSize) {
        _this.$message.error("图片大小不能超过100M");
      }
      return isImage;
    },
    //图片上传
    uploadImage(file) {
      //参数
      let prarms = new FormData();
      prarms.append("file", file.file);
      let _this = this;
      //接口
      homeApi
        .uploadFile(prarms)
        .then((res) => {
          let { data } = res;
          _this.loading = false;
          if (data.errcode === ERR_OK) {
            _this.course.thumb = data.data.url;
          }
        })
        .catch((error) => {
          _this.loading = false;
          console.log(error);
        });
    },
    //图片上传成功
    uploadImageSuccess(res, file) {
      //上传成功
      this.loading = false;
      //上传成功返回数据
      if (res.code == ERR_OK) {
        let data = res.data[0];
        this.course.thumb = data.url;
        this.thumbName = data.fileName;
      }
      //显示图片
      this.fileChange(file);
    },
    //重新上传图片
    fileChange(file) {
      this.$refs.upload.clearFiles(); //清除文件对象
      this.thumb = URL.createObjectURL(file.raw);
    },
    //获取教材章节树
    getBookTreeList() {
      //参数
      let params = {
        bookId: this.book,
      };
      let _this = this;
      //接口
      homeApi
        .getBookTreeList(params)
        .then((res) => {
          let { data } = res;
          if (data.code === ERR_OK) {
            let list = data.data;
            //获取最终章节树
            list.forEach((res) => {
              if (res.chapterList && res.chapterList.length > 0) {
                res.disabled = true;
              }
              _this.getChapterTree(res);
            });
            _this.chapterList = list;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取选中教材
    changeBook(v) {
      if (v.bookId > 0) {
        this.book = v.bookId;
        this.course.bookName = v.bookName;
      } else {
        this.book = "";
        this.course.bookName = "";
      }
    },
    //递归获取最终章节树
    getChapterTree(v) {
      if (v && v.chapterList) {
        v.chapterList.forEach((res) => {
          if (res.chapterList && res.chapterList.length > 0) {
            res.disabled = true;
          }
          this.getChapterTree(res);
        });
      }
    },
    //选择章节
    chooseChapter(v) {
      //获取已选中节点
      let list = this.$refs.chapterTree.getCheckedNodes();
      if (list.length > 0) {
        //选中节点
        this.chapter = [v];
        this.chapterid = v.chapterId;
        //设置单选选中
        this.$refs.chapterTree.setCheckedKeys([v.chapterId]);
        //章节名称
        this.course.chapterName = v.chapterName;
        //课程名称
        this.course.courseName = v.chapterName;
        this.$message({
          message: "已选择章节：" + v.chapterName + "",
          type: "success",
        });
      } else {
        this.chapter = [];
        this.chapterid = 0;
        this.$refs.chapterTree.setCheckedKeys([]);
        this.course.chapterName = "";
        this.course.courseName = "";
        this.$message({
          message: "未选择章节",
          type: "success",
        });
      }
    },
    //保存课程信息
    saveCourse(v) {
      this.$refs["course"].validate((valid) => {
        if (valid) {
          //提示加载
          this.courseload = true;
          //参数
          let chapterId = "";
          if (this.chapter.length > 0) {
            chapterId = this.chapter[0].chapterId;
          } else {
            chapterId = "";
          }
          let classifyName = "";
          for (var i = 0; i < this.classify.length; i++) {
            if (this.course.types == this.classify[i].id) {
              classifyName = this.classify[i].classifyName;
            }
          }
          let params = {
            courseId: this.course.id,
            courseTypeid: this.type,
            schoolId: this.course.schoolid,
            schoolName: this.course.schoolName,
            courseSpeaker: this.course.courseSpeaker,
            subjectId: this.subject,
            gradeId: this.grade,
            bookId: this.book,
            chapterId: chapterId,
            courseName: this.course.courseName,
            courseImg: this.thumbName,
            courseRecomend: parseInt(this.course.home),
            teachers: [],
            courseState: v, //课程状态
            courseClassify: this.course.types,
            courseInfo: this.course.noteContent,
            courseLimit: this.course.courseLimit,
            classifyName: classifyName,
            // commentsIsOpen: this.course.commentsIsOpen,
            // spectatorIsOpen: this.course.spectatorIsOpen,
            // visitorIsOpen: this.course.visitorIsOpen,
          };
          if (this.course.courseLimit == 3) {
            params.schoolIds = this.baseSchoolIds.concat(this.authSchoolIds);
          }
          if (this.course.courseLimit == 5) {
            params.teacherIds = [];
            this.userList.forEach((item) => {
              if (item.userIds !== 0) {
                item.userIds.forEach((item) => {
                  params.teacherIds.push(item);
                });
              }
            });
            if (params.teacherIds.length == 0) {
              this.$message.error("请选择小组成员");
              this.courseload = false;
              return false;
            }
          }
          //主讲人列表
          this.teacher.forEach((res) => {
            let clist = { userId: res.id, userName: res.name };
            params.teachers.push(clist);
          });
          // console.log(params)
          // return

          let _this = this;
          //接口
          homeApi
            .saveCourse(params)
            .then((res) => {
              let { data } = res;
              _this.courseload = false;
              if (data.code === ERR_OK) {
                //提示信息
                let msg = v == 1 ? "课程发布成功" : "课程存草稿成功";
                // _this.$toast.center(msg);
                _this.$message({
                  message: msg,
                  type: "success",
                });
                //更新课程ID
                _this.course.id = data.data > 0 ? data.data : 0;
                _this.courseId = data.data > 0 ? data.data : 0;
              } else {
                // _this.$toast.center(data.msg);
                _this.$message.error(data.msg);
              }
            })
            .catch((error) => {
              _this.courseload = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    // 继续添加
    tiansj() {
      this.$refs.course.resetFields();
      //判断直播次数
      //调用接口获取本学期自行提交的直播次数
      //this.liveNum=调用接口
      this.type = 1;
      this.typeList[0].name = "直播(" + this.liveNum + "/3)次";
      // if (this.liveNum == 3) {
      //   this.type = 2;
      //   this.typeList[0].disabled = true;
      // }
      this.course.id = 0;

      this.course.schoolid = 0;
      this.subject = "";
      this.grade = "";
      this.book = "";
      this.course.chapterName = "";
      this.course.thumb = "";
      this.teacher = [];
      this.$refs.addClass.tiansj();
    },
    // 范围变化
    scopeChange() {
      if (this.course.courseLimit == 3) {
        if (this.course.schoolid == 0) {
          this.$message.error("请选择学校");
          this.course.courseLimit = "";
          return false;
        }
        this.getSchoolList();
      } else if (this.course.courseLimit == 5) {
        if (this.course.schoolid == 0) {
          this.$message.error("请选择学校");
          this.course.courseLimit = "";
          return false;
        }
        this.getUserList();
      } else {
        this.baseSchoolList = [];
        this.authSchoolList = [];
        this.baseSchoolIds = [];
        this.authSchoolIds = [];
      }
    },
    // 小组列表携带成员
    getUserList() {
      let params = {
        groupId: this.groupId,
      };
      homeApi.getUserList(params).then((res) => {
        let list = res.data.data;
        list.forEach((item) => {
          item.userIds = [];
          item.groupIds = false;
        });
        this.userList = list;
        // 编辑数据回显
        if (this.course.id !== 0) {
          this.userList.forEach((item) => {
            item.teamUsers.forEach((items) => {
              let idx = this.teacherIds.indexOf(items.teacherId);
              if (idx !== -1) {
                item.userIds.push(this.teacherIds[idx]);
              }
            });
            if (item.userIds.length == item.teamUsers.length) {
              item.groupIds = true;
            }
          });
        }
      });
    },
    // 组下面学生选中变化
    groupStudent(data) {
      if (data.userIds.length == data.teamUsers.length) {
        this.userList.forEach((item) => {
          if (data.id == item.id) {
            item.groupIds = true;
          }
        });
      } else {
        this.userList.forEach((item) => {
          if (data.id == item.id) {
            item.groupIds = false;
          }
        });
      }
    },
    // 组选中变化
    groupChange(flag, id) {
      this.userList.forEach((item) => {
        if (id == item.id) {
          item.userIds = [];
          if (flag) {
            item.teamUsers.forEach((items) => {
              item.userIds.push(items.teacherId);
            });
          }
        }
      });
    },
    // 获取学校详细信息
    schoolgetinfo(flag) {
      let params = {
        id: this.course.schoolid,
      };
      homeApi.schoolgetinfo(params).then((res) => {
        this.groupId = res.data.data.groupId;
        if (flag == 1 && this.school.id != null) {
          if (this.course.courseLimit == 3) {
            this.getSchoolList(flag);
          }
          if (this.course.courseLimit == 5) {
            this.getUserList();
          }
        }
      });
    },
    // 基地校学校列表
    getSchoolList(flag) {
      let parasm = {
        curPage: 1,
        pageSize: 1000,
        groupId: this.groupId,
      };
      homeApi.getSchoolList(parasm).then((res) => {
        let list = res.data.data.dataList;
        this.baseSchoolList = [];
        this.authSchoolList = [];
        list.forEach((item) => {
          if (item.isPay == 1) {
            this.baseSchoolList.push(item);
            // this.baseSchoolIds.push(item.id);
            if (this.course.id == 0) {
              this.baseSchoolIds.push(item.id);
            }
          } else {
            this.authSchoolList.push(item);
          }
        });
        // 编辑数据回显
        // if (this.course.id !== 0) {
        //   if (this.schoolIds != null) {
        //     this.baseSchoolList.forEach((item) => {
        //       let idx = this.schoolIds.indexOf(item.id);
        //       if (idx !== -1) {
        //         this.baseSchoolIds.push(item.id);
        //       }
        //     });
        //     this.authSchoolList.forEach((item) => {
        //       let idx = this.schoolIds.indexOf(item.id);
        //       if (idx !== -1) {
        //         this.authSchoolIds.push(item.id);
        //       }
        //     });
        //   } else {
        //     list.forEach((item) => {
        //       if (item.isPay == 1) {
        //         this.baseSchoolIds.push(item.id);
        //       }
        //     });
        //   }
        // }
      });
    },
  },
};
</script>
<style scoped>
.course-edit-main {
  padding: 15px;
  min-height: 900px;
}
.course-line {
  border-top: 1px solid #e6e6e6;
  margin: 10px 0 10px 0;
}
.course-back {
  width: 80px;
}
.course-save {
  padding: 10px 0;
}
.class-save {
  padding: 10px 0 50px 0;
}
.course-tab {
  font-family: "PingFang SC";
}
.el-button {
  font-size: 12px;
  min-width: 70px;
  margin: 0 10px 0 0;
}
.button-new-tag {
  height: 28px;
  line-height: 28px;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0;
  border: 1px dashed #b3d8ff;
  border-left: 1px solid #b3d8ff;
  position: relative;
  top: 1px;
}
.chapter-main {
  padding: 15px;
}
.course-edit-main .el-page-header,
.course-edit-main .el-page-header__content {
  font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 700;
}
.course-edit-main .el-form-item {
  margin-bottom: 8px;
}
.course-edit-main .el-form-item .el-form-item__content {
  text-align: left;
}
.course-edit-main .el-input .el-input__inner {
  height: 28px;
  line-height: 28px;
}
.course-edit-main .el-form-item .el-form-item__error {
  font-family: "PingFang SC";
  padding-top: 0px;
}
.course-edit-main .el-tag {
  border-radius: 0;
}
.course-edit-main .el-button--primary.is-disabled {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
.course-edit-main .el-dialog {
  min-width: 550px;
}
.course-edit-main .el-dialog__header {
  text-align: left;
}
.course-edit-main .el-dialog__body {
  padding: 0 20px 20px 20px;
}
.course-edit-main thead .el-checkbox {
  display: none;
}
.course-edit-main .el-upload {
  text-align: left;
}
.course-tab .el-form-item__content .el-tag {
  cursor: pointer;
  margin-right: -5px;
  min-width: 90px;
  text-align: center;
}
.course-tab .el-tag .el-icon-close {
  position: relative;
  top: 0px;
}
.page .el-input .el-input__inner {
  height: 24px;
  line-height: 24px;
}
.course-edit-main .el-upload-list {
  width: 800px;
}

/*上传封面*/
.cover-uploader .el-upload {
  border: 1px solid #eaeaea;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  top: 5px;
}
.cover-uploader .el-upload:hover {
  border-color: #409eff;
}
.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  border: 1px solid;
  border-radius: 4px;
  width: 218px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.cover {
  width: 218px;
  height: 120px;
  display: block;
}
.cover-text {
  color: #8c939d;
  position: absolute;
  bottom: -25px;
  height: 25px;
  line-height: 25px;
}

.upload-list {
  width: 800px;
  background: #ecf5ff;
  margin-top: 10px;
  border-radius: 5px;
}
.upload-list span,
.upload-list a {
  padding: 3px 10px;
}
.upload-list-left {
  /* width: ~"calc(100% - 390px)"; */
  width: 390px;
}
.upload-list-right {
  width: 130px;
}
.upload-btn-del {
  color: #fff;
  cursor: pointer;
  background: #f56c6c;
  border-radius: 3px;
  margin: 0 5px;
}
.upload-btn-down {
  color: #fff;
  cursor: pointer;
  background: #409eff;
  border-radius: 3px;
  margin: 0 5px;
}

.course-ok-btn {
  text-align: right;
  padding: 15px 0 0 0;
}
.editor {
  line-height: normal !important;
  height: 250px;
  margin: 15px 0 60px;
  border-radius: 5px;
}
.base_list {
  background-color: #f8f8f8;
  padding: 10px;
  border-radius: 5px;
}
.listNum {
  color: red;
}
.permissions {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/addCourse.vue